<template>
    <div class="btn-footer mb-0">
        <div v-if="!onEditMode()" class="flex flex-col w-full">
            <div
                v-if="showBackward() && !onEditMode()"
                @click="goBackward"
                class="back"
                :style="{color: color, borderColor: color}"
            >
                Voltar
            </div>
            <div
                v-if="!onEditMode()"
                class="go"
                :style="{backgroundColor: color}"
                :class="!showBackward() ? fullWidth : ''"
                @click="goForward"
            >
                {{ !isLastStep ? 'Continuar' : 'Finalizar'}}
            </div>
        </div>

        <div v-else class="flex flex-col w-full">
            <div
                v-if="onEditMode()"
                class="mobile-outline"
                :style="{color: color, borderColor: color}"
                :class="fullWidth"
                @click="$router.push({ name: 'dashboard-profile-detail' })"
            >
                Cancelar
            </div>
            <div
                v-if="onEditMode()"
                class="mobile-filled"
                :style="{backgroundColor: color}"
                :class="fullWidth"
                @click="doUpdate"
            >
                Atualizar
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'mobile-footer',
    props: {
        step: {
            type: String,
        required: true
        },
    },
    data() {
        return {
            fullWidth: 'w-full'
        }
    },
    computed: {
    ...mapState('step', ['steps', 'currentStep']),
    ...mapGetters('step', ['isLastStep', 'isSecondStep']),
    ...mapState('company', ['company']),
    ...mapState('basicInfo', ['basicInfo']),

        color() {
            return this.company.base_hexcolor || '#1551b1'
        },
    },
    methods: {
        onEditMode() {
            const currentPath = this.$router.history.current.name;
            return (currentPath.slice(0, 4) == 'edit')
        },

        doUpdate() {
            this.$vs.loading({
                text: 'Enviando...'
            })

            if (this.step === 'curriculumn') {
                this.$vs.loading.close()
                this.$router.push({
                    name: 'dashboard-profile-detail'
                })
                return;
            }

            this.persistStepInformation({ step: this.step })
                .then(this.perfomSucessfullResponse)
                .then(() => {
                    this.$vs.loading.close()
                    this.$router.push({ name: 'dashboard-profile-detail' })
                }).catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        text: 'Por favor aguarde alguns instantes e tente realizar a operação novamente.',
                        title: 'Não foi possivel atualizar as informações',
                        icon: 'icon-alert-circle',
                        color: 'warning',
                        iconPack: 'feather',
                    })
                })
        },

        showBackward() {
            return this.isSecondStep ? false : true;
        },

        finishSteps() {
            this.$router.push({ name: 'successfull-application' })
        },

        goForward() {
            if (this.isLastStep) return this.finishSteps()

            if (this.currentStep == 1 && this.currentStepValueEmpty) {
                this.$vs.notify({
                    text: 'Para prosseguir para o próximo passo, é necessário o preenchimento de todas as informações básicas.',
                    title: 'Preencha todas as informações!',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                    iconPack: 'feather',
                    time: 8800,
                })
                return
            }

            if (this.currentStepValueEmpty) {
                this.incrementCurrentStep()
                this.navigate()
                return
            }

            if (this.step == 'curriculumn') {
                this.completeStep()
                this.incrementCurrentStep()
                this.navigate()
                return;
            }
            
            this.$vs.loading({
                text: 'Enviando...'
            })

            this.persistStepInformation({ step: this.step })
                .then(this.perfomSucessfullResponse)
                .then(() => {
                    this.$vs.loading.close()
                    this.completeStep()
                    this.incrementCurrentStep()
                    this.navigate()
                })
                .catch(err => {
                    this.$vs.loading.close();
                    console.error(err);                    
                })
        },

        goBackward() {
            this.decrementCurrentStep()
            this.navigate()
        },
        
        navigate() {
            const { path } = this.steps[this.currentStep]
            this.$router.push({ name: path })
        },

        ...mapActions('step', [
            'incrementCurrentStep',
            'decrementCurrentStep',
            'persistStepInformation',
            'perfomSucessfullResponse',
            'completeStep'
        ]),
    }
}
</script>

<style lang="scss" scoped>
    .bg-gradient {
        background-image: linear-gradient(45deg, #5727B0, #9B27B0) !important;
    }
    .btn-footer {
        display: flex;
        color: white;
        font-weight: 400;
        font-size: 1.25rem;

        .back {
            width: 100%;
            display: flex;
            padding: 1rem;
            justify-content: center;
            border: 1px solid;
            margin-bottom: .5rem;
        }

        .go {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 1rem;
        }

        .mobile-filled {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 1rem;
            background-color: #5727B0;
            margin-top: 4px;
        }

        .mobile-outline {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 1rem;
            border: 1px solid;
            background-color: white;
        }
    }
</style>